import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, map } from 'rxjs';
import Swal from 'sweetalert2';
import { LoginResponse } from '../core/constants/loginResponse.model';
import {
  ChangePasswordPayload,
  ForgotPayload,
  LoginPayload,
  ResetPasswordPayload,
  SignUpBody,
  VerifyOtpPayload,
  VerifyOtpResponse
} from '../models/auth.model';
import { environment } from '../../environments/environment';
import { CommonResponse } from '../models/common.model';
import { ProfilePayload } from '../models/profilePayload.model';
import { PhoneFormat } from '../models/phone';
import { TranslateService } from '@ngx-translate/core';
import { defaultCountryCode } from '../core/constants/defaultNo.const';
import { NotificationResponse } from '../models/notification.model';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  profileDetails: BehaviorSubject<LoginResponse | null> =
    new BehaviorSubject<LoginResponse | null>(null);

  private isOpenSubject = new BehaviorSubject<boolean>(false);
  FCMtoken: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  isOpen$ = this.isOpenSubject.asObservable();
  resetTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  emailSubject: BehaviorSubject<string | null|undefined> = new BehaviorSubject<
    string | null | undefined
  >(null);
  defaultCountryCode = defaultCountryCode;

  resetPhoneSubject: BehaviorSubject<PhoneFormat | null> =
    new BehaviorSubject<PhoneFormat | null>(null);
  constructor(
    private readonly http: HttpClient,
    private _translateService: TranslateService
  ) {}

  isAuthenticated(): boolean {
    if (
      localStorage.getItem(environment.storageKey) &&
      localStorage.getItem(environment.storageKey) !== null
    ) {
      return true;
    } else {
      return false;
    }
  }

  loginAdmin(data: LoginPayload): Observable<LoginResponse> {
    return this.http
      .post<{
        data: LoginResponse;
      }>(`${environment.base_url}login`, data)
      .pipe(map(res => res.data));
  }

  forgotPassword(data: ForgotPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}forgotPassword`,
      data
    );
  }

  resendOTP(data: ForgotPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}sendOtp`,
      data
    );
  }

  verifyOtp(data: VerifyOtpPayload | null): Observable<VerifyOtpResponse> {
    return this.http
      .post<{
        data: VerifyOtpResponse;
      }>(`${environment.base_url}verifyOtp`, data)
      .pipe(map(res => res.data));
  }

  resetPassword(data: ResetPasswordPayload): Observable<CommonResponse> {
    return this.http
      .post<CommonResponse>(`${environment.base_url}resetPassword`, data)
      .pipe(map(res => res));
  }

  getProfile(): Observable<LoginResponse> {
    return this.http
      .get<{ data: LoginResponse }>(`${environment.base_url}getProfile`)
      .pipe(map(res => res.data));
  }

  updateProfile(data: ProfilePayload): Observable<CommonResponse> {
    return this.http
      .put<{
        data: CommonResponse;
      }>(`${environment.base_url}updateProfile`, data)
      .pipe(map(res => res.data));
  }

  changePassword(data: ChangePasswordPayload): Observable<CommonResponse> {
    return this.http
      .post<CommonResponse>(`${environment.base_url}changePassword`, data)
      .pipe(map(res => res));
  }

  logout(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`${environment.base_url}logout`);
  }

  toggleSidebarView(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  signUpUser(payload: SignUpBody): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}signup`,
      payload
    );
  }

  verifyValidate(payload: VerifyOtpPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}verifyValidate`,
      payload
    );
  }

  validateAccount(payload:any): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}validateAccount`,
      payload
    );
  }

  passwordChangedLogout(): Promise<any> {
    return new Promise((resolve: any) => {
      Swal.fire({
        title: this._translateService.instant('PasswordUpdatedSuccessfully'),
        text: this._translateService.instant('Youwillbeloggedout'),
        icon: 'success'
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }

  getHeaderNotification(query?:string): Observable<NotificationResponse> {
    return this.http
      .get<{ data: NotificationResponse }>(`${environment.base_url}getBellNotification?${query}`)
      .pipe(map(res => res.data));
  }
}
